<template>
  <div class="safety-content-editor">
    <a-card title="안전보건 준수사항 관리">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="안전보건 준수사항">
          <a-form :form="form" layout="vertical">
            <a-form-item label="제목">
              <a-input v-model="safetyContent.title" placeholder="안전보건 준수사항" />
            </a-form-item>
            
            <h4>좌측 항목</h4>
            <a-form-item v-for="(item, index) in safetyContent.leftItems" :key="'left-'+index" :label="`항목 ${index+1}`">
              <a-input v-model="safetyContent.leftItems[index]" />
              <a-button 
                v-if="index > 0" 
                type="danger" 
                size="small" 
                shape="circle" 
                icon="delete"
                style="margin-left: 8px"
                @click="removeItem('leftItems', index)" 
              ></a-button>
            </a-form-item>
            <a-button type="dashed" style="width: 100%; margin-bottom: 20px" @click="addItem('leftItems')">
              <a-icon type="plus" /> 항목 추가
            </a-button>
            
            <h4>우측 항목</h4>
            <a-form-item v-for="(item, index) in safetyContent.rightItems" :key="'right-'+index" :label="`항목 ${index+1}`">
              <a-input v-model="safetyContent.rightItems[index]" />
              <a-button 
                v-if="index > 0" 
                type="danger" 
                size="small" 
                shape="circle" 
                icon="delete"
                style="margin-left: 8px"
                @click="removeItem('rightItems', index)" 
              ></a-button>
            </a-form-item>
            <a-form-item v-if="safetyContent.rightItems.length > 0" label="불안전 행동 설명">
              <a-textarea v-model="safetyContent.unsafeActionDesc" rows="4" />
            </a-form-item>
            <a-button type="dashed" style="width: 100%; margin-bottom: 20px" @click="addItem('rightItems')">
              <a-icon type="plus" /> 항목 추가
            </a-button>
            
            <a-form-item label="하단 안내문">
              <a-input v-model="safetyContent.footerNote" placeholder="점검자 업무 및 작업시작 전 점검사항 확인 필수" />
            </a-form-item>
          </a-form>
        </a-tab-pane>
        
        <a-tab-pane key="2" tab="점검자 업무">
          <a-form layout="vertical">
            <a-form-item label="제목">
              <a-input v-model="supervisorContent.title" placeholder="점검자의 업무 (산업안전보건법 시행령 제15조)" />
            </a-form-item>
            
            <h4>업무 항목</h4>
            <a-form-item v-for="(item, index) in supervisorContent.items" :key="index" :label="`항목 ${index+1}`">
              <a-textarea v-model="supervisorContent.items[index]" rows="2" />
              <a-button 
                v-if="index > 0" 
                type="danger" 
                size="small" 
                shape="circle" 
                icon="delete"
                style="margin-left: 8px"
                @click="removeItem('supervisorItems', index)" 
              ></a-button>
            </a-form-item>
            <a-button type="dashed" style="width: 100%; margin-bottom: 20px" @click="addItem('supervisorItems')">
              <a-icon type="plus" /> 항목 추가
            </a-button>
          </a-form>
        </a-tab-pane>
        
        <a-tab-pane key="3" tab="작업시작 전 점검사항">
          <a-form layout="vertical">
            <a-form-item label="제목">
              <a-input v-model="inspectionContent.title" placeholder="점검자 작업시작 전 점검사항 (제35조제2항 관련)" />
            </a-form-item>
            
            <h4>점검 항목</h4>
            <a-collapse accordion>
              <a-collapse-panel v-for="(category, index) in inspectionContent.categories" :key="index" :header="category.title">
                <a-form-item label="카테고리 제목">
                  <a-input v-model="inspectionContent.categories[index].title" />
                </a-form-item>
                
                <h4>점검 항목</h4>
                <a-form-item v-for="(item, itemIndex) in category.items" :key="`item-${index}-${itemIndex}`" :label="`항목 ${itemIndex+1}`">
                  <a-input v-model="inspectionContent.categories[index].items[itemIndex]" />
                  <a-button 
                    v-if="itemIndex > 0" 
                    type="danger" 
                    size="small" 
                    shape="circle" 
                    icon="delete"
                    style="margin-left: 8px"
                    @click="removeInspectionItem(index, itemIndex)" 
                  ></a-button>
                </a-form-item>
                <a-button type="dashed" style="width: 100%; margin-bottom: 20px" @click="addInspectionItem(index)">
                  <a-icon type="plus" /> 항목 추가
                </a-button>
                
                <a-button 
                  v-if="index > 0" 
                  type="danger"
                  style="margin-top: 10px"
                  @click="removeInspectionCategory(index)" 
                >
                  카테고리 삭제
                </a-button>
              </a-collapse-panel>
            </a-collapse>
            
            <a-button type="dashed" style="width: 100%; margin: 20px 0" @click="addInspectionCategory">
              <a-icon type="plus" /> 카테고리 추가
            </a-button>
          </a-form>
        </a-tab-pane>
        
        <a-tab-pane key="4" tab="문구 설정">
          <a-form layout="vertical">
            <a-form-item label="하단 문구">
              <a-input v-model="footerPhrase" placeholder="안전으로 시작해서 품질로 완성하는 우리는 생산/구매본부" />
            </a-form-item>
          </a-form>
        </a-tab-pane>
      </a-tabs>
      
      <div style="margin-top: 20px; text-align: center;">
        <a-button type="primary" @click="saveContent">저장</a-button>
        <a-button style="margin-left: 8px" @click="previewContent">미리보기</a-button>
        <a-button style="margin-left: 8px" @click="downloadHTML" icon="download">HTML 다운로드</a-button>
        <a-button style="margin-left: 8px" @click="exportTemplate" icon="export">템플릿 내보내기</a-button>
        <a-button style="margin-left: 8px" @click="triggerImport" icon="import">템플릿 가져오기</a-button>
        <input type="file" id="template-upload" accept=".json" @change="importTemplate" style="display: none;" />
      </div>
    </a-card>
    
    <!-- 미리보기 모달 -->
    <a-modal
      v-model="previewVisible"
      title="미리보기"
      width="90%"
      :footer="null"
    >
      <div v-html="previewHTML"></div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'SafetyContentEditor',
  data() {
    return {
      form: this.$form.createForm(this),
      previewVisible: false,
      previewHTML: '',
      footerPhrase: '',
      
      // 안전보건 준수사항
      safetyContent: {
        title: '',
        leftItems: [],
        rightItems: [],
        unsafeActionDesc: '',
        footerNote: ''
      },
      
      // 점검자 업무
      supervisorContent: {
        title: '',
        items: []
      },
      
      // 작업시작 전 점검사항
      inspectionContent: {
        title: '',
        categories: []
      },
      
      // 로딩 상태 추가
      loading: true
    }
  },
  mounted() {
    // 서버에서 기존 데이터 가져오기
    this.fetchContent();
  },
  methods: {
    fetchContent() {
      this.loading = true;
      
      // API를 통해 데이터 불러오기
      this.$http.get(this.$store.state.nodeApiUrl + '/product/get_system_data')
        .then((response) => {
          if (response.status === 200 && response.data.code === 'success') {
            let systemData = response.data.data.content[0];
            
            // DB에 저장된 데이터가 있으면 파싱해서 적용
            if (systemData && systemData.safety_compliance) {
              try {
                const data = JSON.parse(systemData.safety_compliance);
                this.safetyContent = data.safetyContent || this.safetyContent;
                this.supervisorContent = data.supervisorContent || this.supervisorContent;
                this.inspectionContent = data.inspectionContent || this.inspectionContent;
                this.footerPhrase = data.footerPhrase || this.footerPhrase;
                this.$message.success('저장된 설정을 불러왔습니다');
              } catch (e) {
                console.error('안전보건 콘텐츠 파싱 오류:', e);
                this.$message.error('데이터 파싱 중 오류가 발생했습니다');
              }
            } else {
              this.$message.info('저장된 데이터가 없습니다. 새로 만들어주세요.');
            }
          } else {
            console.error('시스템 데이터 조회 실패:', response);
            this.$message.error('데이터를 불러오는데 실패했습니다');
          }
          
          this.loading = false;
        })
        .catch(error => {
          console.error('시스템 데이터 조회 오류:', error);
          this.$message.error('서버 연결에 실패했습니다');
          
          // 서버 연결 실패 시 로컬 스토리지에서 불러오기 시도
          this.fetchFromLocalStorage();
          this.loading = false;
        });
    },
    
    // 로컬 스토리지에서 불러오기 (API 실패시 폴백용)
    fetchFromLocalStorage() {
      const savedContent = localStorage.getItem('safetyContent');
      if (savedContent) {
        try {
          const data = JSON.parse(savedContent);
          this.safetyContent = data.safetyContent || this.safetyContent;
          this.supervisorContent = data.supervisorContent || this.supervisorContent;
          this.inspectionContent = data.inspectionContent || this.inspectionContent;
          this.footerPhrase = data.footerPhrase || this.footerPhrase;
          this.$message.info('로컬에 저장된 설정을 불러왔습니다');
        } catch (e) {
          console.error('안전보건 콘텐츠 파싱 오류:', e);
        }
      }
    },
    
    // 아이템 추가
    addItem(type) {
      if (type === 'leftItems') {
        this.safetyContent.leftItems.push('');
      } else if (type === 'rightItems') {
        this.safetyContent.rightItems.push('');
      } else if (type === 'supervisorItems') {
        this.supervisorContent.items.push('');
      }
    },
    
    // 아이템 삭제
    removeItem(type, index) {
      if (type === 'leftItems') {
        this.safetyContent.leftItems.splice(index, 1);
      } else if (type === 'rightItems') {
        this.safetyContent.rightItems.splice(index, 1);
      } else if (type === 'supervisorItems') {
        this.supervisorContent.items.splice(index, 1);
      }
    },
    
    // 점검항목 카테고리 추가
    addInspectionCategory() {
      this.inspectionContent.categories.push({
        title: '새 카테고리',
        items: ['가. 새 항목']
      });
    },
    
    // 점검항목 카테고리 삭제
    removeInspectionCategory(index) {
      this.inspectionContent.categories.splice(index, 1);
    },
    
    // 점검항목 추가
    addInspectionItem(categoryIndex) {
      this.inspectionContent.categories[categoryIndex].items.push('');
    },
    
    // 점검항목 삭제
    removeInspectionItem(categoryIndex, itemIndex) {
      this.inspectionContent.categories[categoryIndex].items.splice(itemIndex, 1);
    },
    
    // 미리보기
    previewContent() {
      // HTML 생성
      this.previewHTML = this.generateHTML();
      this.previewVisible = true;
    },
    
    // 저장
    saveContent() {
      const content = {
        safetyContent: this.safetyContent,
        supervisorContent: this.supervisorContent,
        inspectionContent: this.inspectionContent,
        footerPhrase: this.footerPhrase
      };
      
      // JSON 문자열로 직렬화
      const contentJSON = JSON.stringify(content);
      
      // API를 통해 DB에 저장
      this.$http.post(this.$store.state.nodeApiUrl + '/product/save_system_data', {
        safety_compliance: contentJSON
      }).then((response) => {
        if (response.status === 200) {
          this.$message.success('저장이 완료되었습니다');
          
          // 성공 시 로컬 스토리지에도 백업
          localStorage.setItem('safetyContent', contentJSON);
        } else {
          this.$message.error('저장에 실패했습니다');
          console.error('저장 실패:', response);
        }
      }).catch(error => {
        this.$message.error('저장에 실패했습니다');
        console.error('저장 API 오류:', error);
      });
    },
    
    // HTML 생성
    generateHTML() {
      let html = `
<div style="margin-top: 30px;">
    <!-- 안전보건 준수사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#fffdf0; border: 1px solid #e5e5c9;">
        <tr>
            <td colspan="2" style="padding: 5px; text-align: center; font-weight: bold; font-size: 14px; border-bottom: 1px solid #e5e5c9;">${this.safetyContent.title}</td>
        </tr>
        <tr>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6; border-right: 1px solid #e5e5c9;">
                ${this.safetyContent.leftItems.map(item => `<div>${item}</div>`).join('')}
            </td>
            <td style="width:50%; padding:5px 10px; vertical-align:top; font-size:12px; line-height:1.6;">
                ${this.safetyContent.rightItems.map(item => `<div>${item}</div>`).join('')}
                ${this.safetyContent.unsafeActionDesc ? `<div style="color:#ff0000; font-size:11px; line-height:1.4;">${this.safetyContent.unsafeActionDesc}</div>` : ''}
            </td>
        </tr>
        <tr>
            <td colspan="2" style="padding:5px; text-align:center; font-size:11px; border-top: 1px solid #e5e5c9;">${this.safetyContent.footerNote}</td>
        </tr>
    </table>
    
    <!-- 점검자 업무 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; background-color:#ffffff; border: 1px solid #e5e5c9; border-top: none;">
        <tr>
            <td style="padding:5px; text-align:center; font-size:11px; font-weight:bold;">${this.supervisorContent.title}</td>
        </tr>
        <tr>
            <td style="padding:5px 10px; font-size:11px; line-height:1.5;">
                ${this.supervisorContent.items.map(item => `<div style="margin-bottom:3px;">${item}</div>`).join('')}
            </td>
        </tr>
    </table>
    
    <!-- 점검자 작업시작 전 점검사항 테이블 -->
    <table style="width:100%; border-collapse: collapse; table-layout:fixed; margin-top:20px; border: 1px solid #e5e5c9; font-size:11px;">
        <tr>
            <td colspan="2" style="padding:6px; text-align:center; background-color:#f0f0f0; font-weight:bold; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.title}
            </td>
        </tr>`;
      
      // 카테고리를 2개씩 짝지어 행을 구성
      for (let i = 0; i < this.inspectionContent.categories.length; i += 2) {
        html += `
        <tr>
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i].title}
            </td>`;
        
        // 홀수 카테고리가 있는 경우
        if (i + 1 < this.inspectionContent.categories.length) {
          html += `
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i + 1].title}
            </td>`;
        } else {
          // 마지막 홀수 카테고리인 경우 빈 셀 추가
          html += `
            <td style="width:50%; padding:6px; text-align:center; background-color:#f0f0f0; border-bottom: 1px solid #e5e5c9;">
                
            </td>`;
        }
        
        html += `
        </tr>
        <tr>
            <td style="padding:6px; vertical-align:top; border-right: 1px solid #e5e5c9; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i].items.map(item => `<div>${item}</div>`).join('')}
            </td>`;
        
        // 홀수 카테고리의 항목이 있는 경우
        if (i + 1 < this.inspectionContent.categories.length) {
          html += `
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                ${this.inspectionContent.categories[i + 1].items.map(item => `<div>${item}</div>`).join('')}
            </td>`;
        } else {
          // 마지막 홀수 카테고리인 경우 빈 셀 추가
          html += `
            <td style="padding:6px; vertical-align:top; border-bottom: 1px solid #e5e5c9;">
                
            </td>`;
        }
        
        html += `
        </tr>`;
      }
      
      html += `
    </table>
    
    <!-- 안전으로 시작해서 품질로 완성하는 문구 -->
    <div style="width:100%; text-align:center; margin-top:10px; font-weight:bold; color:#ff0000; font-size:13px;">
        ${this.footerPhrase}
    </div>
</div>
      `;
      
      return html;
    },
    
    // HTML 생성 후 파일로 다운로드 기능 추가
    downloadHTML() {
      const html = this.generateHTML();
      const blob = new Blob([html], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = '안전보건준수사항.html';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    
    // 템플릿 파일 내보내기
    exportTemplate() {
      const content = {
        safetyContent: this.safetyContent,
        supervisorContent: this.supervisorContent,
        inspectionContent: this.inspectionContent,
        footerPhrase: this.footerPhrase
      };
      
      const blob = new Blob([JSON.stringify(content, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = '안전보건준수사항_템플릿.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      this.$message.success('템플릿이 내보내기되었습니다.');
    },
    
    // 템플릿 파일 가져오기
    importTemplate(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const content = JSON.parse(e.target.result);
          this.safetyContent = content.safetyContent || this.safetyContent;
          this.supervisorContent = content.supervisorContent || this.supervisorContent;
          this.inspectionContent = content.inspectionContent || this.inspectionContent;
          this.footerPhrase = content.footerPhrase || this.footerPhrase;
          this.$message.success('템플릿을 성공적으로 가져왔습니다.');
        } catch (error) {
          console.error('템플릿 파일 파싱 오류:', error);
          this.$message.error('유효하지 않은 템플릿 파일입니다.');
        }
      };
      reader.readAsText(file);
      
      // 파일 선택 초기화
      event.target.value = '';
    },
    
    // 파일 업로드 트리거
    triggerImport() {
      document.getElementById('template-upload').click();
    }
  }
}
</script>

<style scoped>
.safety-content-editor {
  padding: 20px;
}
</style> 